import { Injectable, ElementRef, Renderer } from '@angular/core';

import { ApiService, CacheService, LogService, SeoService, AppContext } from '../../shared';
import { Contacts } from '../../shared/models/contacts';
import { Carrier, Vessel, Trips } from '../../shared/models';
import * as data from './carrier-network.data.json';
import { reject } from 'q';

@Injectable()
export class CarrierNetworkService {
  queryString: string = '';

  public loaderOff = false;
  public noResult = false;
  public newSearch = false;
  public localContactsLoader = false;
  el: HTMLElement;
  content: HTMLElement;
  container: HTMLElement;

  constructor(private api: ApiService, private cache: CacheService, private logger: LogService,
    private seo: SeoService, public app: AppContext, el: ElementRef, private renderer: Renderer) {
  }

  getCarriers(): Promise<Array<Carrier>> {
    this.logger.log('carrier-network.service', 'getCarriers', null);
    // let cache = this.cache.get('carriers' + carrierId);
    let promise = this.callGetCarriers();
    // let server = Observable.fromPromise(promise);
    // this.carrier = server;
    // this.carrier = Observable.concat(cache, server);
    // this.cache.updateCache('carriers' + this.queryString, this.carrier);

    return promise;
  }

  callGetCarriers(): Promise<Array<Carrier>> {
    this.logger.log('carriers.service', 'callGetCarriers', data);
    return new Promise((resolve, reject) => {
      try {
        let result = data;
        let carriers = this.formatCarriers(result);

        resolve(carriers);
      } catch (ex) {
        reject(null);
      }
    });
  }

  formatCarriers(result): Array<Carrier> {
    let carriers = Array<Carrier>();

    for (let current = 0; current < result.length; current++) {
      let carrier = new Carrier(result[current].carrier);
      carriers.push(carrier);
    }

    return carriers;
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/static/carrier-network/carrier-network.service.ts